import { SET_NET_PULSE_DATA, SET_NET_PULSE_LOADING, DATA_FETCH_INIT, SET_ORGANIZATIONS_LOADING, SET_DEVICES_LOADING, } from "./types";
const initialState = {
    isNetPulseLoading: false,
    isDataLoading: false,
    organizationsLoading: false,
    devicesLoading: false,
    organizations: [],
    devices: [],
    device: {},
};
export default function netPulseReducer(state = initialState, action) {
    switch (action.type) {
        case SET_NET_PULSE_DATA:
            return { ...state, ...action.payload };
        case SET_NET_PULSE_LOADING:
            return { ...state, isNetPulseLoading: true };
        case DATA_FETCH_INIT:
            return { ...state, isDataLoading: true, ...(action.payload ?? {}) };
        case SET_ORGANIZATIONS_LOADING:
            return { ...state, organizationsLoading: action.payload };
        case SET_DEVICES_LOADING:
            return { ...state, devicesLoading: action.payload };
        default:
            return state;
    }
}
